import { inject, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router } from "@angular/router";
import { filter, map, pairwise } from "rxjs";

@Injectable()
export class RouterTrackerService {
  private readonly router = inject(Router);
  private lastPair: readonly [string, string] = ["", ""];

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((x) => x.urlAfterRedirects),
        pairwise(),
        takeUntilDestroyed()
      )
      .subscribe((pair) => {
        this.lastPair = pair;
      });
  }

  get previousUrl(): string {
    return this.lastPair[0];
  }

  get currentUrl(): string {
    return this.lastPair[1];
  }
}
